export const projectDetailsDefaults = {
  organisationId: undefined,
  organisationKey: undefined,
  organisationName: '',
  projectName: '',
};
